var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import adminTracking from "@irati-tracking/admin";
import { getThumbnailImage } from "@irati/utils/images/getImageSize/getImageSize";
import HR from "@irati/ui/src/Layout/Hr";
import Toggle from "@irati/ui/src/FormItem/Toggle";
import Flex from "@irati/ui/src/Flex";
import DescriptionModal from "../DealDescription";
import ToggleWrapper from "../styled/ToggleWrapper";
import ThumbnailImage from "../styled/ThumbnailImage";
import { StyledH5, StyledIconBtn } from "./styled";
var DealListItem = /** @class */ (function (_super) {
    __extends(DealListItem, _super);
    function DealListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: null,
            showModal: false
        };
        _this.openModal = function () {
            _this.setState({
                showModal: true
            });
        };
        _this.closeModal = function () {
            _this.setState({
                showModal: false
            });
        };
        _this.handleToggle = function () {
            var _a = _this.props, handleToggle = _a.handleToggle, deal = _a.deal, blacklisted = _a.blacklisted;
            adminTracking.changePerkVisibility(deal, blacklisted ? "show" : "hidden");
            var load = handleToggle(deal.uuid).then(function () {
                _this.setState({ load: null });
            });
            _this.setState({ load: load });
        };
        return _this;
    }
    DealListItem.prototype.render = function () {
        var _a = this.props, deal = _a.deal, blacklisted = _a.blacklisted;
        var _b = this.state, showModal = _b.showModal, load = _b.load;
        var effect = blacklisted ? "grayscale" : null;
        var isDealHeaderCropped = deal.header.length > 120;
        return (React.createElement(React.Fragment, null,
            React.createElement(Flex, { justifyContent: "space-between", alignItems: "center" },
                React.createElement(Flex, { justifyContent: "space-between", alignItems: "center" },
                    React.createElement(ThumbnailImage, { src: getThumbnailImage(deal.thumbnailImage, effect) }),
                    React.createElement(StyledH5, { grey: blacklisted },
                        deal.header,
                        !isDealHeaderCropped &&
                            React.createElement(StyledIconBtn, { icon: "question", inline: true, size: 24, top: 7, onClick: this.openModal }))),
                React.createElement(Flex, { alignItems: "center" },
                    isDealHeaderCropped &&
                        React.createElement(StyledIconBtn, { icon: "question", inline: true, size: 24, top: 4, onClick: this.openModal }),
                    React.createElement(ToggleWrapper, null,
                        React.createElement(Toggle, { load: load, checked: !blacklisted, icons: false, onClick: this.handleToggle })))),
            React.createElement(HR, null),
            showModal && React.createElement(DescriptionModal, { onHide: this.closeModal, deal: deal })));
    };
    DealListItem.defaultProps = {
        blacklisted: false
    };
    return DealListItem;
}(Component));
export default DealListItem;
